/* eslint-disable no-console */
import { ApiClient, Helper, CustomHeadersService } from "zoox-infra";
import moment from "moment";
import i18n from "../middlewares/i18n";
import Vue from "vue";
import ReservationImage from "@/components/shared/GuestForm/Model/ReservationImage";
import Reservation from "@/components/shared/GuestForm/Model/Reservation";

export default class ReservationService {
  constructor() {
    this.apiClient = new ApiClient();
    this.reservationStatus = {
      TO_CONFIRM: 0,
      CONFIRMED: 1,
      CHECK_IN: 2,
      CHECK_OUT: 3,
      PENDING: 4,
      NO_SHOW: 5,
      CANCELLED: 6,
      WAIT_LIST: 7,
      IN_ATTEMPT: 8
    };
    this.SearchMethodsEnum = {
      RECOGNITION: 6,
      RESERVATION: 1,
      DOCUMENT: 2,
      NAME: 3,
      EMAIL: 4,
      CHECKIN_RESERVATIONS: 5
    };
  }
  /**
   * Obtains a list of reservations by given parameters
   * @param  {[type]} companyId         [description]
   * @param  {[type]} reservationNumber [description]
   * @param  {[type]} documentTypeId    [description]
   * @param  {[type]} documentNumber    [description]
   * @param  {[type]} name              [description]
   * @param  {[type]} lastName          [description]
   * @param  {[type]} email             [description]
   * @param  {[type]} checkinDate       [description]
   * @param  {[type]} checkoutDate      [description]
   * @return {[type]}                   [description]
   */
  getAll(
    companyId,
    reservationNumber = null,
    documentTypeId = null,
    documentNumber = null,
    name = null,
    lastName = null,
    email = null,
    checkinDate = null,
    checkoutDate = null
  ) {
    let url =
      "portal/reservation/list?page=0&per_page=100&sort=checkinDate&order=desc";

    if (companyId) {
      url += `&companyId=${companyId}`;
    }

    if (reservationNumber) {
      url += `&reservationNumber=${reservationNumber}`;
    }

    if (documentTypeId != null && documentTypeId != undefined) {
      url += `&guests.documentTypeId=${documentTypeId}`;
    }

    if (documentNumber) {
      documentNumber = documentNumber.replace(/\D/g, "");
      url += `&guests.documentNumber=${documentNumber}`;
    }

    if (name && lastName && checkinDate && checkoutDate) {
      url += `&guests.name=^${name}`;
    }

    if (lastName) {
      url += `&guests.lastName=^${lastName}`;
    }

    if (checkinDate) {
      url += `&checkinDate=>=${moment
        .utc(checkinDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
    }

    if (checkoutDate) {
      url += `&checkoutDate=<=${moment
        .utc(checkoutDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
    }

    if (email) {
      url += `&guests.email=${email}`;
    }
    return this.apiClient.get(url);
  }

  /**
   * Returns all reservations of a given date
   * @param  {String} companyId Company ID
   * @param  {Date} date      Date
   * @return {[type]}           [description]
   */
  getAllOfDate(companyId, date) {
    return this.apiClient.get(
      `open/reservation/list?page=0&per_page=100&sort=checkinDate&order=desc&companyId=${companyId}&checkinDate=>=${moment
        .utc(date)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}&checkinDate=<=${moment
        .utc(date)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`
    );
  }

  async getRawReservation(companyId, reservationNumber) {
    return this.apiClient.get(
      `reservation/raw/${companyId}/${reservationNumber}?useImport=false`
    );
  }

  /**
   * Obtans a list of reservations by person
   * @param  {[type]} personId    Person id
   * @param  {[type]} companyId   Company id
   * @param  {[type]} checkinDate Checkin Date
   * @return {[type]}             [description]
   */
  getAllByPerson(personId, personList, companyId, checkinDate) {
    let url = "";
    if (personId) {
      url = `open/reservation/list/person/${personId}`;
    } else if (personList) {
      const emailList = [];

      // filtramos os e-mails dos providers como filtro
      // pois o email principal do person está contido
      // obrigatoriamente em algum dos providers tambem
      for (let x in personList) {
        if (personList[x].providers) {
          for (let y in personList[x].providers) {
            if (
              personList[x].providers[y].email &&
              emailList.indexOf(personList[x].providers[y].email) <= -1
            ) {
              emailList.push(personList[x].providers[y].email);
            }
          }
        }
      }
      url =
        "open/reservation/list?page=0&per_page=100&sort=checkinDate&order=desc&guests.email=" +
        emailList.join(",");
    }

    if (companyId) {
      url = Helper.updateQueryString("companyId", companyId, url);
    }

    if (checkinDate) {
      url += `&checkinDate=>=${moment
        .utc(checkinDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")}`;
    }

    return this.apiClient.get(url);
  }

  /**
   * Obtains a reservation by Id
   * @return {[type]}    [description]
   * @param reservationId
   */
  getOne(reservationId) {
    if (this.isAuthorized()) {
      return this.apiClient.get(`reservation/${reservationId}?ota=1`);
    }
    const ota = 1;
    return this.getById({ reservationId, ota });
  }

  async getById({ reservationId, hash, ota }) {
    let url = `portal/reservation/${reservationId}?z=1`;
    if (hash != null) {
      url += `&hash=${hash}`;
    }
    if (ota != null) {
      url += `&ota=1`;
    }
    return this.apiClient.get(url);
  }

  /**
   * Updates a reservation
   * @param  {String} id          Reservation Id
   * @param  {Object} reservation Reservation Data
   * @param  {Boolean} finalize If must finalize the reservation
   * @return {[type]}             [description]
   */
  update(id, reservation, finalize) {
    let url = `open/reservation-v3/${id}`;
    if (finalize) {
      url = Helper.updateQueryString("finalize", 1, url);
    }

    // 2 - portal
    url = Helper.updateQueryString("origin", 2, url);

    return this.apiClient.put(url, reservation);
  }

  /**
   * Obtains the current reservation in-memory stored
   * @return {Object} Current reservation object
   */
  getLocalReservation() {
    const reservation = localStorage.getItem("currentReservation");
    if (reservation) {
      return JSON.parse(reservation);
    }

    return new Reservation();
  }

  /**
   * Sets the current reservation in memory
   * @param {Object} reservation Reservation to store
   */
  setLocalReservation(reservation) {
    this.sanitizeReservation(reservation);
    localStorage.setItem("currentReservation", JSON.stringify(reservation));
  }

  /**
   * Sanitizes the reservation object
   * @param  {Object} reservation Original reservation Object
   * @return {[type]}             [description]
   */
  sanitizeReservation(reservation) {
    delete reservation._links;
  }

  /**
   * Returns all the reservation search methods
   * @param  {Boolean} hasEmail If has email
   * @return {Array}           Array with search methods
   */
  getSearchMethods(hasEmail) {
    let searchMethods = [];
    if (hasEmail) {
      searchMethods = [
        {
          value: this.SearchMethodsEnum.RECOGNITION,
          text: i18n.t("WELCOME.SEARCH_METHODS.RECOGNITION")
        },
        {
          value: this.SearchMethodsEnum.DOCUMENT,
          text: i18n.t("WELCOME.SEARCH_METHODS.DOCUMENT")
        }
      ];
    } else {
      searchMethods = [
        {
          value: this.SearchMethodsEnum.RECOGNITION,
          text: i18n.t("WELCOME.SEARCH_METHODS.RECOGNITION")
        },
        {
          value: this.SearchMethodsEnum.RESERVATION,
          text: i18n.t("WELCOME.SEARCH_METHODS.RESERVATION")
        },
        {
          value: this.SearchMethodsEnum.DOCUMENT,
          text: i18n.t("WELCOME.SEARCH_METHODS.DOCUMENT")
        },
        {
          value: this.SearchMethodsEnum.NAME,
          text: i18n.t("WELCOME.SEARCH_METHODS.NAME")
        },
        {
          value: this.SearchMethodsEnum.EMAIL,
          text: i18n.t("WELCOME.SEARCH_METHODS.EMAIL")
        },
        {
          value: this.SearchMethodsEnum.CHECKIN_RESERVATIONS,
          text: i18n.t("WELCOME.SEARCH_METHODS.CHECKIN_RESERVATIONS")
        }
      ];
    }
    return searchMethods;
  }

  /**
   * Auto fills a reservation
   * @param  {String} reservationId Reservation ID
   * @param  {String} personId      Person ID
   * @param  {Object} data          Data to autofill
   * @return {[type]}               Promise with updated reservation
   */
  autoFill(reservationId, personId, data) {
    return this.apiClient.post(
      `open/reservation/${reservationId}/autofill/${personId}`,
      data,
      null,
      false
    );
  }

  /**
   * Searches a person by document number
   * @param  {String} reservationId  Reservation ID
   * @param  {String} documentNumber Document Number
   * @param  {String} documentTypeId Document Type Id
   * @return {[type]}                Promise with updated reservation
   */
  searchPerson(reservationId, documentNumber, documentTypeId) {
    return this.apiClient.get(
      `open/reservation/${reservationId}/searchperson?q=${documentNumber}&document_type_id=${documentTypeId}`,
      null,
      false
    );
  }

  /**
   * Sets the guest/reservation picture to save on server
   * @param {Object} reservation Reservation object
   * @param {Object} guest       Guest object
   * @param {String} imageData   Image DATA_URL
   */
  setGuestImage(reservation, guest, imageData) {
    Vue.set(guest, "imageName", new Date().getTime());

    const image = new ReservationImage();
    image.name = guest.imageName;
    image.content = imageData;

    Vue.set(reservation, "image", image);
  }

  /**
   * Validates the guest data
   * @param  {Object} guest Current guest
   * @return {Boolean}      Guest valid or not
   */
  validateGuest(
    guest,
    config = {},
    excludeOtherInfo = false,
    excludeEmail = false
  ) {
    //return true;
    let ok = true;

    if (!config.personalData && !guest.name) {
      console.error("!guest.name");
      return false;
    }

    if (!config.personalData && !guest.lastName) {
      console.error("!guest.lastName");
      return false;
    }

    if (!excludeEmail && !config.emailData && !guest.email) {
      console.error("!guest.email");
      return false;
    }

    if (!excludeEmail && !config.mobileNumberData && !guest.mobileCityCode) {
      console.error("!guest.mobileCityCode");
      return false;
    }

    if (!excludeEmail && !config.mobileNumberData && !guest.mobilePhoneNumber) {
      console.error("!guest.mobilePhoneNumber");
      return false;
    }

    // ddd mobile so é obrigatorio se guest for Brasileiro!
    /*console.error("phone number mobile ", guest.mobilePhoneNumber)
    console.error("extract ddd mobile ", this.extractDDD(guest.mobilePhoneNumber))
    if (guest.nationalityId === "BR" && !this.extractDDD(guest.mobilePhoneNumber)) {
      console.error("br without ddd mobile");
      return false;
    }*/

    if (
      !config.documentData &&
      (guest.documentTypeId == null || guest.documentTypeId == undefined)
    ) {
      console.error(
        "guest.documentTypeId == null || guest.documentTypeId == undefined"
      );
      return false;
    }

    if (!config.documentData && !guest.documentNumber) {
      console.error("!guest.documentNumber");
      return false;
    }

    if (!config.residenceCountryData && !guest.countryId) {
      console.error("!guest.countryId");
      return false;
    }

    if (!config.nationalityCountryData && !guest.nationalityId) {
      console.error("!guest.nationalityId");
      return false;
    }

    if (!config.genderData && !guest.gender) {
      console.error("!guest.gender");
      return false;
    }

    if (!config.birthdateData && !guest.birthdate) {
      console.error("!guest.birthdate");
      return false;
    }

    if (!config.zipcodeData && guest.countryId === "BR" && !guest.zipCode) {
      console.error("!guest.zipCode");
      return false;
    }

    if (!config.cityData && guest.countryId === "BR" && !guest.cityName) {
      console.error("!guest.cityName");
      return false;
    }

    if (!config.stateData && guest.countryId === "BR" && !guest.stateName) {
      console.error("!guest.stateName");
      return false;
    }

    if (!config.addressData && !guest.address) {
      console.error("!guest.address");
      return false;
    }

    if (!config.addressNumberData && !guest.addressNumber) {
      console.error("!guest.addressNumber");
      return false;
    }

    if (
      !config.neighborhoodData &&
      guest.countryId === "BR" &&
      !guest.neighborhood
    ) {
      console.error("!guest.neighborhood");
      return false;
    }

    if (!excludeEmail && !config.jobData && !guest.jobName) {
      console.error("!guest.jobName");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.nextDestinationCountryData &&
      !guest.nextDestinationCountryId
    ) {
      console.error("!guest.nextDestinationCountryId");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.nextDestinationStateData &&
      guest.nextDestinationCountryId === "BR" &&
      !guest.nextDestinationStateName
    ) {
      console.error("!guest.nextDestinationStateName");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.nextDestinationCityData &&
      guest.nextDestinationCountryId === "BR" &&
      !guest.nextDestination
    ) {
      console.error(
        "guest.nextDestinationCountryId === br && !guest.nextDestination"
      );
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.nextDestinationCityData &&
      guest.nextDestinationCountryId === "BR" &&
      !guest.nextDestinationName
    ) {
      console.error("!guest.nextDestinationName");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.arrivingFromCountryData &&
      !guest.arrivingFromCountryId
    ) {
      console.error("!guest.arrivingFromCountryId");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.arrivingFromStateData &&
      guest.arrivingFromCountryId === "BR" &&
      !guest.arrivingFromStateName
    ) {
      console.error("!guest.arrivingFromStateName");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.arrivingFromCityData &&
      guest.arrivingFromCountryId === "BR" &&
      !guest.arrivingFrom
    ) {
      console.error(
        "guest.arrivingFromCountryId === br && !guest.arrivingFrom"
      );
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.arrivingFromCityData &&
      guest.arrivingFromCountryId === "BR" &&
      !guest.arrivingFromName
    ) {
      console.error("!guest.arrivingFromName");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.transportTypeData &&
      !guest.arrivingByName
    ) {
      console.error("!guest.arrivingByName");
      return false;
    }

    if (
      !excludeOtherInfo &&
      !config.purposeTripData &&
      !guest.purposeTripName
    ) {
      console.error("!guest.purposeTripName");
      return false;
    }

    return ok;
  }

  async getPersonId(reservationId, guestId) {
    let resp;
    try {
      resp = await this.apiClient.get(
        `portal/contact-info/${reservationId}/${guestId}`,
        false
      );
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return resp;
    }
  }

  updateLocalGuest(guestId, updatedGuest) {
    const reservation = this.getLocalReservation();
    for (let x in reservation.guests) {
      const guest = reservation.guests[x];
      if (guest.id !== guestId) {
        continue;
      }
      Object.assign(reservation.guests[x], updatedGuest);
    }
    this.setLocalReservation(reservation);
    return reservation;
  }

  isAuthorized() {
    const headers = CustomHeadersService.getCustomHeaders();
    return (
      headers != null &&
      (headers.Authorization != null || headers.authorization != null)
    );
  }

  setValidatedInfo(validated) {
    localStorage.setItem("validatedInfo", JSON.stringify(validated));
  }

  getValidatedInfo() {
    const validated = localStorage.getItem("validatedInfo");
    if (validated == null) return {};
    return JSON.parse(validated);
  }

  async saveDocs(guestId, data) {
    return this.apiClient.post(
      `open/reservation/${guestId}/documents`,
      data,
      null,
      false
    );
  }

  async checkIfReservationIsExpiredOrCanceled(reservationId) {
    const storagedReservation = this.getLocalReservation();

    if (storagedReservation.id !== reservationId) {
      localStorage.clear();
      window.location.reload();
    }

    if (reservationId != null) {
      const reservations = await this.getOne(reservationId);

      const STATUS_CANCELED = 6;
      const today = moment().format("L");
      const checkoutDate = moment(
        reservations.checkoutDate.split("T")[0]
      ).format("L");

      const expiredCheckoutDate = moment(today).isAfter(checkoutDate);
      const canceledStatus = reservations.resStatus === STATUS_CANCELED;

      if (expiredCheckoutDate) {
        return { status: true, type: "expired" };
      } else if (canceledStatus) {
        return { status: true, type: "cancelled" };
      } else {
        return { status: false };
      }
    }
  }
}
